<template>
  <Header>
    <template #menu-additional>
      <div class="Menu__additional">
        <div
          class="Menu__wrapper"
          v-intro="$t('HINTS.HOME_HINT_STEP_3')"
          v-intro-step="3"
          v-intro-if="hints('home')"
        >
          <li class="Menu__item">
            <router-link to="/news" class="Menu__link" active-class>
              {{ $t("HOME") }}
            </router-link>
          </li>
          <li
            class="Menu__item"
            @click="managePopupState({ popup: 'partnersForm', _state: true })"
          >
            <a href="#">{{ $t("FOR_PARTNERS") }}</a>
          </li>

          <!-- <li
            class="Menu__item"
            @click="managePopupState({ popup: 'volunteersForm', _state: true })"
          >
            <a href="#">{{ $t("FOR_VOLUNTEERS") }}</a>
          </li>-->
          <router-link to="/volunteers" class="Menu__item">
            <a href="#">{{ $t("FOR_VOLUNTEERS") }}</a>
          </router-link>
          <router-link to="/mobile" class="Menu__item">
            <a href="#">{{ $t("MOBILE_APP") }}</a>
          </router-link>
        </div>
      </div>
    </template>

    <template #share>
      <Share
        wrapper="Nav"
        :icons="share.icons"
        v-intro="$t('HINTS.HOME_HINT_STEP_4')"
        v-intro-step="4"
        v-intro-if="hints('home')"
      />
    </template>
  </Header>
</template>

<script>
import { Header } from "@/components";
import { Share } from "@/components/app";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MainHeader",
  computed: {
    ...mapGetters(["share", "hints"])
  },
  methods: {
    ...mapMutations(["managePopupState"])
  },
  components: {
    Header,
    Share
  }
};
</script>
